import React from "react";
import { RefreshCw } from "lucide-react";

import "./RefreshButton.css";

const RefreshButton = ({
  onClick,
  loading = false,
  disabled = false,
  label = "Refresh",
  size = 16,
  className = "",
}) => {
  return (
    <button
      type="button"
      className={`refresh-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      aria-label={label}
      aria-busy={loading}
    >
      <RefreshCw
        size={size}
        className={loading ? "refresh-button__icon--loading" : ""}
      />

      <span className="refresh-button__label">
        {loading ? "Refreshing..." : label}
      </span>
    </button>
  );
};

export default RefreshButton;
